// When is larger than mobile/ medium remove nav open class
const disableOnBreakpoint = (toggle) => {
  window.addEventListener('resize', () => {
    const mediaSize = window.matchMedia('(max-width: 991px)');
    if (!mediaSize.matches) {
      document.body.classList.remove('nav-is-open');
      document.querySelector('.header-demo .button')?.classList.add('button--bg-white');
      toggle.setAttribute('aria-expanded', 'false');
      // document.body.style.top = '';
    }
  });
};

const mobileMenu = () => {
  const toggle = document.querySelector('.nav-toggle');
  // const adminBarHeight = document.querySelector('#wpadminbar')?.clientHeight ?? 0;

  if (!toggle) {
    return;
  }

  let scrollY = window.scrollY;
  let savedScrollY = scrollY;

  toggle.addEventListener('click', () => {
    scrollY = window.scrollY;

    // Set nav active to edit related elements
    document.body.classList.toggle('nav-is-open');
    document.querySelector('.header-demo .button')?.classList.toggle('button--bg-white');

    // Aria Label expanded
    if (document.body.classList.contains('nav-is-open')) {
      toggle.setAttribute('aria-expanded', 'true');
      // document.body.style.top = `-${scrollY - adminBarHeight}px`;
      savedScrollY = scrollY;
    }
    else {
      toggle.setAttribute('aria-expanded', 'false');
      window.scrollTo({
        top: parseInt(savedScrollY || '0'),
        left: 0,
        behavior: 'instant'
      });
      document.body.style.top = '';
    }
  });

  // Enable if is mobile/ medium menu
  disableOnBreakpoint(toggle);
};

const setHeaderHeight = () => {
  const header = document.querySelector('.header');
  const body = document.body;
  const adminBar = document.querySelector('#wpadminbar');
  const mediaMobileSize = window.matchMedia('(max-width: 1023px)');
  const adminBarNotFixedSize = window.matchMedia('(max-width: 600px)');
  const extraPadding = !mediaMobileSize.matches ? 0 : 0;

  let paddingTop = '(header?.clientHeight ?? 0) + (adminBar?.clientHeight ?? 0) ?? 0';

  if (adminBarNotFixedSize.matches) {
    paddingTop = ((header?.clientHeight ?? 0) ?? 0) + extraPadding;
    header.style.top = '0px';
  }
  else {
    paddingTop = (header?.clientHeight ?? 0) + ((adminBar?.clientHeight ?? 0) ?? 0) + extraPadding;
    header.style.top = `${adminBar?.clientHeight ?? 0}px`;
  }

  body.style.paddingTop = `${paddingTop}px`;
};

const subMenuToggle = () => {
  const itemsWithSubMenu = document.querySelectorAll('.nav-main .menu-item.menu-item-has-children');

  if (!itemsWithSubMenu.length) {
    return false;
  }

  const toggle = (item, itemsWithSubMenu) => {
    itemsWithSubMenu.forEach(innerItem => {
      if (innerItem !== item && item.classList.contains('menu-item-has-children')) {
        innerItem.classList.remove('is-open');
      }
    });

    item.classList.toggle('is-open');
  };

  itemsWithSubMenu.forEach(item => {
    const trigger = item.querySelector('a.nav-main-link');

    if (!trigger) {
      return false;
    }

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      toggle(item, itemsWithSubMenu);
    });
  });
};

const closeSubmenusWhenClickOutside = () => {
  window.addEventListener('click', e => {
    const menu = document.querySelector('.header-nav .nav-main');

    if (menu && !menu.contains(e.target)) {
      const openItems = menu.querySelectorAll('.is-open');

      if (openItems.length > 0) {
        openItems.forEach(item => {
          item.classList.remove('is-open');
        });
      }
    }
  });
};

export default () => {
  mobileMenu();
  // setHeaderHeight();
  subMenuToggle();
  closeSubmenusWhenClickOutside();

  window.addEventListener('resize', () => {
    // setHeaderHeight();
  });
}
